import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import BackButton from 'component/button/Back'
import SubmitButton from 'component/button/Submit'
import { FormSwitch } from 'component/forms'
import {
  FormInputName,
  FormInputUrutan,
  FormSelectSection,
  FormSelectPrecontent,
  FormInputTanggal,
  FormSelectQuiz,
  FormActiveKey,
  FormActiveStatus,
  FormSelectFeedback,
  FormGroupKecil,
  FormInputDesc,
  FormInputEndedAt,
  FormTextArea,
  FormCheckTypeRapor,
  FormSelectStudent,
} from 'component/content-form'

export default function AddContentQuiz() {
  /* ========================================== Helpers ========================================= */
  const history  = useHistory()
  const location = useLocation()
  const params = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* ========================================= Constants ======================================== */
  const links = [
    { url: '/kelas', name: 'Sub Mata Pelajaran' },
    { url: `/kelas/${location.state.kelasId}`, name: 'Overview' },
  ]
  const contentType = 6
  const sections = location.state.sectionList ? location.state.sectionList : []

  /* ======================================= Local States ======================================= */
  const [existingContents, setExistingContents] = useState([])
  const [quizList, setQuizList]             = useState([])
  const [namaKonten, setNamaKonten]         = useState('')
  const [urutan, setUrutan]                 = useState('')
  const [sectionId, setSectionId]           = useState('')
  const [preContentId, setPrecontentId]     = useState('')
  const [active, setActive]                 = useState(0)
  const [durasi, setDurasi]                 = useState('')
  const [displayAt, setDisplayAt]           = useState('')
  const [quizId, setQuizId]                 = useState(null)
  const [feeds, setFeeds]                   = useState([])
  const [feedId, setFeedId]                 = useState(null)
  const [isFeedActive, setIsFeedActive]     = useState(0)
  const [enableGroup, setEnableGroup]       = useState(false)
  const [maxGroup, setMaxGroup]             = useState('')
  const [descGroup, setDescGroup]           = useState('')
  const [endedAt, setEndedAt]               = useState('')
  const [description, setDescription]       = useState('')
  const [apresiasi, setApresiasi]           = useState('')
  const [rating, setRating]                 = useState(1)
  const [isPengetahuan, setIsPengetahuan]   = useState(false)
  const [isKeterampilan, setIsKeterampilan] = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])

  const [enableGroupKey, setEnableGroupKey] = useState(false)
  const [prerequisite, setPrerequisite]     = useState('')

  // FORM VALIDATION STATES
  const [isNamaInvalid, setIsNamaInvalid]       = useState(false)
  const [isUrutanInvalid, setIsUrutanInvalid]   = useState(false)
  const [isSectionInvalid, setIsSectionInvalid] = useState(false)
  const [isQuizInvalid, setIsQuizInvalid]       = useState(false)
  const [isMaxGroupValid, setIsMaxGroupValid]   = useState(true)
  const [loadingSubmit, setLoadingSubmit]       = useState(false)

  /* =========================================== Refs =========================================== */
  const refInputName     = useRef()
  const refSelectSection = useRef()
  const refInputUrutan   = useRef()
  const refSelectQuiz    = useRef()
  const refMaxGroup      = useRef()

  /* ========================================= Functions ======================================== */
  function getExistingContentsBySelectedSection() {
    if (!sectionId) {
      setExistingContents([])
    } else {
      sections.forEach((section) => {
        if (section.id === sectionId) {
          setExistingContents(section.contents)
        }
      })
    }
  }

  async function getQuizList() {
    const response = await getRequest('quiz')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.title,
      }))
      setQuizList(options)
    }
  }

  async function getFeedsList() {
    const response = await getRequest('feed')
    if (response) {
      const options = response.data.map((item) => ({
        value: item.id,
        label: item.description,
      }))
      setFeeds(options)
    }
  }

  function handleChangeName(event) {
    setNamaKonten(event.target.value)
  }

  function handleChangeUrutan(event) {
    setUrutan(Math.abs(event.target.value))
  }

  function handleChangeSection(event) {
    setSectionId(event.target.value)
  }

  function handleChangePrecontent(event) {
    setPrecontentId(event.target.value)
  }

  function handleChangeEnableGroupKey() {
    if (enableGroupKey) {
      setEnableGroupKey(false)
    } else {
      setEnableGroupKey(true)
    }
  }

  function handleChangeDate(event) {
    setDisplayAt(event.target.value)
  }

  function handleChangeActive() {
    if (active === 1) {
      setActive(0)
    }
    if (active === 0) {
      setActive(1)
    }
  }

  function handleChangeQuiz(val) {
    setQuizId(val)
  }

  function handleChangeFeedback(val) {
    setFeedId(val)
  }

  function handleChangeEnableGroup() {
    if (enableGroup) {
      setEnableGroup(false)
      setMaxGroup('')
      setIsMaxGroupValid(true)
    } else {
      setEnableGroup(true)
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeMaxGroup(event) {
    if (event.target.value) {
      const absolute = Math.abs(event.target.value)
      const integer = Math.round(absolute)
      setMaxGroup(integer)
      if (integer <= 0) {
        setIsMaxGroupValid(false)
      } else {
        setIsMaxGroupValid(true)
      }
    } else {
      setMaxGroup('')
      setIsMaxGroupValid(false)
    }
  }

  function handleChangeDescGroup(event) {
    setDescGroup(event.target.value)
  }

  function handleChangeDesc(event) {
    setDescription(event.target.value)
  }

  function handleChangeEndedAt(event) {
    setEndedAt(event.target.value)
  }

  function handleChangeApresiasi(event) {
    setApresiasi(event.target.value)
  }

  function handleChangeRating(value) {
    setRating(value ? 1 : 0)
  }

  function handleChangeIsPengetahuan(event) {
    setIsPengetahuan(event.target.checked)
  }

  function handleChangeIsKeterampilan(event) {
    setIsKeterampilan(event.target.checked)
  }

  function handleFormValidation() {
    const durasiDetik = durasi * 60
    const feedback = isFeedActive === 1 ? feedId : ''

    if (namaKonten && urutan && sectionId && quizId && isMaxGroupValid) {
      const contentsUrl = { quiz_id: quizId.value }
      setIsNamaInvalid(false)
      setIsSectionInvalid(false)
      setIsUrutanInvalid(false)
      setIsQuizInvalid(false)
      handleFormSubmit(
        namaKonten,
        contentType,
        sectionId,
        urutan,
        active,
        displayAt,
        preContentId,
        contentsUrl,
        feedback.value,
        durasiDetik,
        maxGroup,
        descGroup,
        endedAt,
        description,
        apresiasi,
        rating,
        isPengetahuan,
        isKeterampilan,
      )
    } else {
      if (!isMaxGroupValid) {
        if (refMaxGroup) {
          refMaxGroup.current.focus()
        }
      }

      if (!sectionId) {
        setIsSectionInvalid(true)
        refSelectSection.current.focus()
      } else {
        setIsSectionInvalid(false)
      }

      if (!urutan) {
        setIsUrutanInvalid(true)
        refInputUrutan.current.focus()
      } else {
        setIsUrutanInvalid(false)
      }

      if (!quizId) {
        setIsQuizInvalid(true)
        refSelectQuiz.current.focus()
      } else {
        setIsQuizInvalid(false)
      }

      if (!namaKonten) {
        setIsNamaInvalid(true)
        refInputName.current.focus()
      } else {
        setIsNamaInvalid(false)
      }

      window.notification('Mohon', 'lengkapi data')
    }
  }

  async function handleFormSubmit(
    namaKonten,
    contentType,
    sectionId,
    urutan,
    active,
    displayAt,
    preContentId,
    contentsUrl,
    feedId,
    durasi,
    maxGroup,
    descGroup,
    endedAt,
    description,
    apresiasi,
    rating,
    isPengetahuan,
    isKeterampilan,
  ) {
    let form = new FormData()
    form.append('title', namaKonten)
    form.append('content_type', contentType)
    form.append('section_id', sectionId)
    form.append('urutan', urutan)
    form.append('active', active)
    form.append('contents_url', JSON.stringify(contentsUrl))
    // form.append("durasi", durasi);
    form.append('rating', rating)
    form.append('is_pengetahuan', isPengetahuan)
    form.append('is_keterampilan', isKeterampilan)

    if (Array.isArray(selectedStudents) && !!selectedStudents.length) {
      selectedStudents.forEach((selectedStudent, selectedStudentIndex) => {
        form.append(`spesifik_user_id[${selectedStudentIndex}]`, selectedStudent.id)
      })
    }

    if (displayAt) {
      form.append('display_at', displayAt)
    }

    if (endedAt) {
      form.append('ended_at', endedAt)
    }

    if (description) {
      form.append('deskripsi', description)
    }

    if (preContentId) {
      form.append('precontent_id', preContentId)
    }

    if (feedId) {
      form.append('feedback', feedId)
    }

    if (enableGroup) {
      form.append('group_status', 1)
      if (maxGroup) {
        form.append('group_max', maxGroup)
      }
      if (descGroup) {
        form.append('group_description', descGroup)
      }
    }

    if (apresiasi) {
      form.append('apresiasi', apresiasi)
    }

    setLoadingSubmit(true)

    const response = await postRequest('contents', form)
    if (response) {
      if (enableGroupKey) {
        let formkey = new FormData()
        formkey.append('description', prerequisite)
        formkey.append('content_id', response.data.id)

        const response1 = await postRequest('contentTakeAway', formkey)
        if (response1) {
          window.notification('Materi', 'berhasil ditambahkan', 'success')
          history.goBack()
        }
      } else {
        window.notification('Materi', 'berhasil ditambahkan', 'success')
        history.goBack()
      }
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getExistingContentsBySelectedSection()
  }, [sectionId])

  useEffect(() => {
    getQuizList()
    getFeedsList()
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Tambah Quiz"
          linkName="Quiz"
          links={links}
        />
        
        <div className="row">
          <div className="col">
            <div className="card">
              <div className="card-header">
                <h5>
                  <i className="fas fa-question-circle mr-1" />
                  Informasi Quiz
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <form>
                      {/* Input Nama Konten */}
                      <FormInputName
                        label="Nama Quiz"
                        placeholder="Nama Quiz"
                        namaKonten={namaKonten}
                        handleChangeName={handleChangeName}
                        isNamaInvalid={isNamaInvalid}
                        refInputName={refInputName}
                      />

                      {/* Form Group Select Quiz */}
                      <FormSelectQuiz
                        existingQuiz={quizList}
                        handleChangeQuiz={handleChangeQuiz}
                        isQuizInvalid={isQuizInvalid}
                        refSelectQuiz={refSelectQuiz}
                        getQuizList={getQuizList}
                      />

                      <FormCheckTypeRapor
                        handleChangeIsPengetahuan={handleChangeIsPengetahuan}
                        handleChangeIsKeterampilan={handleChangeIsKeterampilan}
                        isPengetahuan={isPengetahuan}
                        isKeterampilan={isKeterampilan}
                      />

                      {/* Input Urutan */}
                      <FormInputUrutan
                        urutan={urutan}
                        handleChangeUrutan={handleChangeUrutan}
                        isUrutanInvalid={isUrutanInvalid}
                        refInputUrutan={refInputUrutan}
                      />

                      {/* Input deskripsi */}
                      <FormInputDesc
                        description={description}
                        handleChangeDesc={handleChangeDesc}
                      />

                      {/* Input Apresiasi */}
                      <FormTextArea
                        id="formInputApresiasi"
                        label="Apresiasi"
                        placeholder="Apresiasi/pesan setelah siswa menyelesaikan materi (opsional)"
                        className="mb-5"
                        value={apresiasi}
                        handleChange={handleChangeApresiasi}
                      />

                      {/* Select Section */}
                      <FormSelectSection
                        sections={sections}
                        handleChangeSection={handleChangeSection}
                        isSectionInvalid={isSectionInvalid}
                        refSelectSection={refSelectSection}
                      />

                      {/* Select Precontent */}
                      <FormSelectPrecontent
                        existingContents={existingContents}
                        handleChangePrecontent={handleChangePrecontent}
                      />

                      {/* Input Tanggal Ditampilkan */}
                      <FormInputTanggal
                        existingDisplayAt={displayAt}
                        handleChangeDate={handleChangeDate}
                      />

                      {/* Input ended at */}
                      <FormInputEndedAt
                        endedAt={endedAt}
                        handleChangeEndedAt={handleChangeEndedAt}
                      />

                      {/* Input durasi */}
                      {/* <FormDurasi 
                        existingDurasi={durasi}
                        handleChangeDurasi={handleChangeDurasi}
                      /> */}

                      {/* Rating */}
                      <FormSwitch
                        id="formRating"
                        label="Rating Materi"
                        value={rating}
                        handleChange={handleChangeRating}
                      />

                      {/* Select feedback */}
                      <FormSelectFeedback
                        existingFeeds={feeds}
                        existingFeedId={feedId}
                        isFeedActive={isFeedActive}
                        setIsFeedActive={setIsFeedActive}
                        handleChangeFeeds={handleChangeFeedback}
                        getFeedList={getFeedsList}
                      />

                      {/* Swicth Group Kecil */}
                      <FormGroupKecil
                        enableGroup={enableGroup}
                        handleChangeEnableGroup={handleChangeEnableGroup}
                        maxGroup={maxGroup}
                        descGroup={descGroup}
                        handleChangeMaxGroup={handleChangeMaxGroup}
                        handleChangeDescGroup={handleChangeDescGroup}
                        isMaxGroupValid={isMaxGroupValid}
                        refMaxGroup={refMaxGroup}
                      />

                      {/* Select Specific Students */}
                      <FormSelectStudent 
                        selectedStudents={selectedStudents}
                        setSelectedStudents={setSelectedStudents}
                        subMapelId={params?.kelasId}
                        isWithCheckSavedOrNot={false}
                      />

                      {/* Select Status */}
                      <FormActiveStatus
                        existingStatus={active}
                        handleChangeStatus={handleChangeActive}
                      />

                      <FormActiveKey
                        enableGroupKey={enableGroupKey}
                        handleChangeEnableGroupKey={handleChangeEnableGroupKey}
                        prerequisite={prerequisite}
                        setPrerequisite={setPrerequisite}
                      />

                      <div className="form-group">
                        <BackButton />
                        {loadingSubmit ? (
                          <button
                            disabled={true}
                            type="button"
                            className="btn btn-success mr-2"
                          >
                            <span
                              className="spinner-border spinner-border-sm mr-1"
                              role="status"
                            />
                            <span>Simpan</span>
                          </button>
                        ) : (
                          <SubmitButton
                            onClick={() => handleFormValidation()}
                            text="Simpan"
                          />
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
